import { getUrlQuery } from '../../text/utils/utils';
import { DEFAULT_IMAGE_HEIGHT, DEFAULT_IMAGE_WIDTH, DEFAULT_VIDEO_HEIGHT, DEFAULT_VIDEO_WIDTH } from '../constants';
import { IBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/base-model.interface';
import { isAudioElement, isVideoElement } from '@src/slide/domain/ui-model/elements/element-judge';

/**
 * 在给定的容器中计算比例固定的矩形的最大尺寸
 * @param aspectRatio
 * @param containerWidth
 * @param containerHeight
 * @returns
 */
export function getMaxSizeInContainer(aspectRatio: any, containerWidth: number, containerHeight: number) {
    if (typeof aspectRatio !== 'number' || Number.isNaN(aspectRatio)) {
        return {
            width: containerWidth,
            height: containerHeight,
        };
    }
    const ratio = containerWidth / containerHeight;
    let width = containerWidth;
    let height = containerHeight;
    if (ratio > aspectRatio) {
        width = height * aspectRatio;
    } else {
        height = width / aspectRatio;
    }
    return { width, height };
}

/**
 * 根据传入的宽高比例计算默认的视频大小
 * 保证视频宽高不会超出默认值范围
 * @param aspectRatio
 * @returns
 */
export function getDefaultVideoSizeByRatio(aspectRatio: any) {
    return getMaxSizeInContainer(aspectRatio, DEFAULT_VIDEO_WIDTH, DEFAULT_VIDEO_HEIGHT);
}

/**
 * 根据传入的宽高比例计算默认的图片附件大小
 * 保证视频宽高不会超出默认值范围
 * @param aspectRatio
 * @returns
 */
export function getDefaultImageSizeByRatio(aspectRatio: any) {
    return getMaxSizeInContainer(aspectRatio, DEFAULT_IMAGE_WIDTH, DEFAULT_IMAGE_HEIGHT);
}

/**
 * 根据附件传入的宽高比例计算默认的附件封面大小
 * 保证宽高不会超出默认值范围
 * @param model
 * @param w
 * @param h
 * @returns { width: number, height: number }
 */
export function getAttachmentDefaultSizeByRatio(model: IBaseModel, w: number, h: number):
{width: number, height: number} {
    const width = Number(w);
    const height = Number(h);
    if (!(width && height && !Number.isNaN(width) && !Number.isNaN(height))) return { width: w, height: h };

    const aspectRatio = width / height;
    if (isVideoElement(model)) return getDefaultVideoSizeByRatio(aspectRatio);
    return { width: w, height: h };
}

/**
 * 根据图片地址获取图片宽高比
 * @param src
 * @returns
 */
export function getAspectRatioFromSrc(src?: string) {
    if (!src) {
        return;
    }
    const { w, h } = getUrlQuery(src);
    return getAspectRatio(w, h);
}

export function getAspectRatio(w: string | number, h: string| number) {
    const width = Number(w);
    const height = Number(h);
    if (width && height && !Number.isNaN(width) && !Number.isNaN(height)) {
        // 保证 width height 都是有效的数字
        return width / height;
    }
}

/**
 * 判断 aspectRatio 是否合法
 * @param aspectRatio
 * @returns
 */
export function isValidAspectRatio(aspectRatio: any) {
    return !(typeof aspectRatio !== 'number' || Number.isNaN(aspectRatio));
}

/**
 * 请求获取图片的宽高
 * @param url
 * @returns
 */
export function fetchImageSize(url: string): Promise<{width: number, height: number}> {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = function () {
            const { width, height } = img;
            resolve({ width, height });
        };
        img.onerror = function () {
            reject(new Error('Failed to load image'));
        };
        img.src = url;
    });
}
